import { render, staticRenderFns } from "./collectDetail.vue?vue&type=template&id=623d3830&scoped=true&"
import script from "./collectDetail.vue?vue&type=script&lang=js&"
export * from "./collectDetail.vue?vue&type=script&lang=js&"
import style0 from "./collectDetail.vue?vue&type=style&index=0&id=623d3830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d3830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623d3830')) {
      api.createRecord('623d3830', component.options)
    } else {
      api.reload('623d3830', component.options)
    }
    module.hot.accept("./collectDetail.vue?vue&type=template&id=623d3830&scoped=true&", function () {
      api.rerender('623d3830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/collect/collectDetail.vue"
export default component.exports